import React from 'react'
import AnimatedSymbol from './AnimatedSymbol'

type Props = {
  symbol: React.FC<{
    className?: string
    style?: React.CSSProperties
  }>
  symbolStyle?: React.CSSProperties
  children: React.ReactNode
}

export default function SymbolHeading({
  symbol,
  symbolStyle,
  children,
}: Props) {
  return (
    <div className="text-center">
      <AnimatedSymbol symbol={symbol} symbolStyle={symbolStyle} />
      <h2 className="type-med-plus-fat -mt-24 mb-24 lg:mb-40">{children}</h2>
    </div>
  )
}
